import styled from "styled-components"

export const WheelhouseSectionWrapper = styled.div`
	display: flex;
	justify-content: flex-end;
	align-items: center;
	position: relative;
	> div.containerWheelhouseSection {
		border: 1px solid #e5e4e4;
		padding: 12px;
		border-radius: 8px;
		display: grid;
		grid-template-columns: 1fr auto;
		grid-template-rows: 1fr;
		justify-content: space-between;
		gap: 16px;
		.first {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			gap: 8px;
			> div {
				&:nth-child(2) {
					display: flex;
					justify-content: flex-start;
					align-items: center;
					gap: 4px;
					span {
						display: flex;
						justify-content: flex-start;
						align-items: center;
						font-size: 12px;
						&:first-of-type {
						}
						&:last-child {
							color: #130080;
						}
					}
				}
				&:nth-child(3) {
					color: #5b3fff;
					display: flex;
					justify-content: center;
					align-items: center;
				}
			}
		}
		.second {
			display: flex;
			justify-content: flex-end;
			align-items: center;
			button {
				border: 1px solid #e5e4e4;
				border-radius: 8px;
				background-color: transparent;
				padding: 5px 8px;
				color: #646264;
				font-size: 12px;
				cursor: pointer;
			}
		}
	}
`
